import { render, staticRenderFns } from "./CertifPartBundling.vue?vue&type=template&id=0a255d96&scoped=true"
import script from "./CertifPartBundling.vue?vue&type=script&lang=js"
export * from "./CertifPartBundling.vue?vue&type=script&lang=js"
import style0 from "./CertifPartBundling.vue?vue&type=style&index=0&id=0a255d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a255d96",
  null
  
)

export default component.exports